import { actionCopyIt } from "./actionCopy";
import { listCopyIt } from "./listCopy";

export const templatesCopyIt = {
    templates: "Modelli",
    navDescription: "Sfogli i modelli e inviti i pazienti a monitorare i propri esiti.",
    myTemplatesTitle: "I miei modelli",
    myTemplatesDescription:
        "Crei e gestisca modelli per invitare rapidamente i pazienti a monitorare i propri esiti. Faccia clic su una riga per usare un modello, oppure apra il menu per altre azioni.",
    myTemplatesAria: "I miei modelli",
    publicTemplatesTitle: "Modelli pubblici",
    breadcrumbNew: "Nuovo",
    selectAtLeastOneTemplate: "Selezioni almeno un modello",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Aggiungere il modello al mio account" : `Aggiungere ${count} modelli al mio account`,
    creatingTemplates: "Creazione dei modelli…",
    publicTemplatesDescription:
        "Sfogli configurazioni pronte all'uso e le aggiunga al Suo account, oppure crei le Sue. Selezioni un modello per iniziare rapidamente.",
    browsePublic: "Sfogliare i modelli pubblici",
    browsePublicAria: "Sfogliare i modelli pubblici",
    newTemplate: "Nuovo modello",
    newTemplateAria: "Nuovo modello",
    makeMyOwn: "Creare il mio",
    favourites: "Preferiti",
    noQuestionnaires: "Nessun questionario",
    moreQuestionnaires: (count) => `+${count} altri`,
    useTemplate: "Usare il modello",
    newDiary: "Nuovo diario",
    searchPlaceholder: "Cercare modelli...",
    searchAria: "Cercare modelli",
    clearSearchAria: actionCopyIt.clearSearch,
    filters: actionCopyIt.filters,
    clearAll: actionCopyIt.clearAll,
    procedureFilterPrefix: "Intervento:",
    statusFilterPrefix: "Stato:",
    substanceFilterPrefix: "Sostanza:",
    subsiteFilterPrefix: "Sottosede:",
    siteFilterPrefix: "Sede:",
    typeFilterPrefix: "Tipo:",
    areaFilterPrefix: "Area:",
    consultationFilterPrefix: "Consulto:",
    removeProcedureFilterAria: (label) => `Rimuovere il filtro di intervento ${label}`,
    removeStatusFilterAria: (label) => `Rimuovere il filtro di stato ${label}`,
    removeOwnerFilterAria: (name) => `Rimuovere il filtro del proprietario ${name}`,
    removePeopleFilterAria: (name) => `Rimuovere il filtro delle persone ${name}`,
    removeSubstanceFilterAria: "Rimuovere il filtro della sostanza",
    removeSubsiteFilterAria: "Rimuovere il filtro della sottosede",
    removeSiteFilterAria: "Rimuovere il filtro della sede",
    removeShockwaveTypeFilterAria: "Rimuovere il filtro del tipo di onde d'urto",
    removeAreaFilterAria: "Rimuovere il filtro dell'area",
    removeConsultationFilterAria: "Rimuovere il filtro del consulto",
    ownerFilterLabel: "Proprietario (clinico o segretario)",
    ownerFilterPlaceholder: "Tutti gli utenti",
    statusFilterLabel: "Stato",
    statusFilterPlaceholder: "Tutti gli stati",
    peopleOnTemplateLabel: "Persone sul modello",
    peopleOnTemplatePlaceholder: "Qualsiasi persona sul modello",
    procedureTypeLabel: "Tipo di intervento",
    procedureTypePlaceholder: "Qualsiasi tipo di intervento",
    areaLabel: "Area",
    substanceLabel: "Sostanza",
    subsiteLabel: "Sottosede",
    typeLabel: "Tipo",
    siteLabel: "Sede",
    consultationLabel: "Consulto",
    selectPlaceholder: "Selezionare...",
    clearFilterAria: (label) => `Cancellare ${label}`,
    injection: "Iniezione",
    shockwave: "Onde d'urto",
    surgery: "Chirurgia",
    consultation: "Consulto",
    medication: "Farmaco",
    product: "Prodotto",
    published: listCopyIt.published,
    draft: listCopyIt.draft,
    noTemplatesYet: "Nessun modello al momento",
    noMatchingTemplates: "Nessun modello corrispondente",
    noTemplatesYetHint: "Crei il Suo primo modello per invitare rapidamente i pazienti.",
    noMatchingHint: "Provi a modificare la ricerca o i filtri.",
    createFirstTemplate: "Creare il Suo primo modello",
    emptyTemplatesHelpLink: "Come creare un modello?",
    tableHint:
        "Faccia clic su una riga per invitare un paziente da questo modello. Usi « Nuovo diario » e la modifica su ogni riga, oppure apra il menu per i preferiti e altre azioni.",
    forms: "Moduli",
    lastEdited: "Ultima modifica",
    procedure: "Intervento",
    area: "Area",
    people: "Persone",
    details: "Dettagli",
    actions: listCopyIt.actions,
    select: "Selezionare",
    useTemplateAria: "Nuovo diario",
    editTemplateAria: "Modificare il modello",
    tapToUseTemplate: "Prema per usare questo modello",
    useThisTemplateAria: "Usare questo modello",
    clickRowToUseAria: "Faccia clic sulla riga per usare questo modello",
    publicTemplatesTableAria: "Modelli pubblici",
    yourTemplatesTableAria:
        "I Suoi modelli; scelga una riga per usare questo modello, oppure usi le azioni di ogni riga",
    noTemplatesInView: "Nessun modello in questa vista.",
    showingTemplatesRange: (start, end, total) => `Modelli da ${start} a ${end} di ${total}`,
    previous: actionCopyIt.previous,
    next: actionCopyIt.next,
    save: actionCopyIt.save,
    rename: actionCopyIt.rename,
    editTemplate: "Modificare il modello",
    addToFavourites: "Aggiungere ai preferiti",
    removeFromFavourites: "Rimuovere dai preferiti",
    copyUrl: "Copiare l'URL",
    shareTemplate: "Condividere il modello",
    labelsAndDiaryType: "Etichette e tipo di diario",
    publishTemplate: "Pubblicare il modello",
    duplicate: actionCopyIt.duplicate,
    delete: actionCopyIt.delete,
    deleteTemplateTitle: "Eliminare il modello",
    deleteTemplateDescription: "Desidera davvero eliminare questo modello? Questa azione è irreversibile.",
    cancel: actionCopyIt.cancel,
    templateUpdatedToast: "Modello aggiornato correttamente",
    copiedToClipboardToast: "Copiato negli appunti",
    unnamedTemplate: "Modello senza nome",
    questionnaireSchedule: "Calendario del questionario",
    interventionStep: "Intervento",
    injectionDetails: "Informazioni sull'iniezione",
    surgeryClinicians: "Clinici dell'operazione",
    surgeryDetails: "Informazioni sull'operazione",
    shockwaveClinicians: "Clinici delle onde d'urto",
    shockwaveDetails: "Informazioni sulle onde d'urto",
    noIntervention: "Nessun intervento",
    dateStep: "Data",
    dateQuestion: "Da quale data si contano i follow-up?",
    dateDiaryStart: "Dal giorno in cui viene creato il diario",
    dateDiaryStartHint: "I questionari iniziano subito. Al paziente non viene chiesta una data.",
    dateAskPatient: "Lasciare vuoto - ce lo indica il paziente",
    dateAskPatientHint: "Il paziente indica la data quando configura il diario. Può anche aggiungerla in seguito.",
    saveTemplate: "Salvare il modello",
    lockLabel: "Blocca",
    unlockLabel: "Sblocca",
    lockedLabel: "Bloccato",
    lockScope: {
        trackers: "Questionari",
        "tracker.schedule": "Calendari",
        consents: "Consensi",
        event: "Intervento",
        "person.injectingClinicianId": "Clinico che esegue l'iniezione",
        "person.referringClinicianId": "Medico inviante",
        "person.operatingClinicianId": "Clinico operatore",
        "person.productId": "Prodotto",
    },
    lockedByTemplateCreator: "Bloccato dal creatore del modello",
    usageInstructionsPlaceholder: "ad es. Indossare 2 ore al giorno, pulire dopo ogni utilizzo",
    productNameRequired: "Il nome del prodotto è obbligatorio",
    contactEmail: "E-mail di contatto",
    contactPersonDescription:
        "Una persona che il paziente può contattare se desidera un ulteriore contatto con l'ambulatorio. Questa e-mail sarà condivisa con il paziente.",
    selectContactPlaceholder: "Selezionare un'e-mail di contatto",
    defaultContactForOrganisation: (organisationNames) => `Predefinito per ${organisationNames}`,
    templateCreatedTitle: "Modello creato correttamente.",
    templateCreatedMessage: "Il tempo risparmiato è tempo guadagnato.",
    templateNotFoundTitle: "Modello non trovato",
    templateNotFoundDescription: "Impossibile trovare il modello. La preghiamo di riprovare.",
    backToTemplates: "Tornare ai modelli",
    userFallback: (idPrefix) => `Utente ${idPrefix}...`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Iniezione",
            shockwave: "Onde d'urto",
            surgery: "Chirurgia",
            education: "Consulto",
            medication: "Farmaco",
            product: "Prodotto",
        };
        return map[type] ?? type;
    },
    statusLabel: (status) => (status === "published" ? "Pubblicato" : "Bozza"),
};
